import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import Tour from 'reactour'
import {Button} from "antd";
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
// import {dashBoardSteps} from "./TourUtils";
import TourStepContent from './TourStepContent'
import { editTourDashboard, setToursDashboardFilters, setStatusTourDashboard } from '../../actions/TourAction'
class BunkeyDashboardTour extends Component {
  _isMounted = false;
  constructor(props) {
    super(props)

    this.state = {
      steps: [],
      isTourOpen: false,
    }
    this.current = -1
  }

  disableBody = target => disableBodyScroll(target)
  enableBody = target => enableBodyScroll(target)

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidMount(){
    const { intl, tourDashboardFiltersFinished, user, tourDashboard } = this.props
    var dashLocal = []
    if ( user && 
      tourDashboard && tourDashboard.length !== 0 &&
      !tourDashboardFiltersFinished) {
      var newDashboard = []
      var type_user = null;
      if (user.role === 'admin') {
        type_user = 'superadmin'
      } else {
        type_user = user.clientRole
      }
      tourDashboard.forEach((r) => {
        r.classname = 's_menu_' + r.number
        if (r.type_user === 'all') {
          newDashboard.push({...r})
        } else {
          if (type_user === r.type_user) {
            newDashboard.push({...r})
          }
          if ((type_user === 'admin' || type_user === 'superadmin') && r.type_user === 'su-admin') {
            newDashboard.push({...r})
          }
        }
      })
      dashLocal = newDashboard
      this.props.setToursDashboardFilters(newDashboard);
      if (newDashboard.length === 0) {
        this.props.setStatusTourDashboard(true)
      }
    }

    var stepsValuesTourDashboard = []
    if (dashLocal && dashLocal.length !== 0) {
      dashLocal.forEach((r) => {
        r.content = <TourStepContent
          title = {intl.formatMessage({id: 'dashboard_' + r.title})}
          subtitle = {intl.formatMessage({id: 'dashboard_' + r.description})}
        />
        stepsValuesTourDashboard.push({...r})
      })
    }

    const seen = stepsValuesTourDashboard.length === 0;
    if(seen) return;
    this.setState({ 
      isTourOpen: true,
      steps: stepsValuesTourDashboard,
    });
  }

  componentDidUpdate() {
  
  }

  handleSeenSteps = () => {
    const { user, tourDashboardFilters } = this.props
    const stepsView = []
    if (tourDashboardFilters && tourDashboardFilters.length) {
      for (let i = 0; i < this.current; i++) {
        stepsView.push(tourDashboardFilters[i].number)
      }
    }
    this.props.editTourDashboard(user._id, stepsView)
    // 
    // localStorage.setItem(`dashboard_tour_${user._id}`, true)
    this.setState({ isTourOpen: false })
  }

  handleBadgeContent = (current, total) => {
    const { intl } = this.props
    this.current = current
    return `${current} ${intl.formatMessage({ id: 'of' })} ${total}`
  }

  render() {
    const { steps } = this.state
    const savedColor = localStorage.getItem('primaryColor');
    const MenuIcon = (props) =>(
      <svg width="12" height="21" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5607 0.439332C12.1464 1.02511 12.1464 1.97484 11.5607 2.56062L3.62127 10.5L11.5607 18.4394C12.1464 19.0252 12.1464 19.9749 11.5607 20.5607C10.9749 21.1464 10.0252 21.1464 9.43938 20.5607L0.439333 11.5606C-0.146444 10.9749 -0.146444 10.0251 0.439333 9.43936L9.43938 0.439332C10.0252 -0.146444 10.9749 -0.146444 11.5607 0.439332Z" fill={props.fill}/>
      </svg>
    )
    return (
      <React.Fragment>
        {steps && steps.length > 0 && <Tour
          accentColor={savedColor}
          badgeContent={this.handleBadgeContent}
          steps={steps}
          rounded={5}
          isOpen={this.state.isTourOpen}
          maskSpace={20}
          style = {{
            width: 500
          }}
          onAfterOpen={this.disableBody}
          onBeforeClose={this.enableBody}
          lastStepNextButton={<Button
            size={'large'}
            type={'primary'}
            block
          >
            Entendido
          </Button>}
          onRequestClose={this.handleSeenSteps}
          showNavigation={true}
          // prevButton={<img src={TourPrevIcon} className='prevButtonImg' alt="prev" />}
          prevButton={
            <MenuIcon fill={savedColor} />
          }
          nextButton={<Button
            size={'large'}
            type={'primary'}
            block
          >
            Siguiente
          </Button>}
        />}
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.authUser.user,
    token: state.authUser.token,
    tourDashboard: state.tours.tourDashboard,
    tourDashboardFilters: state.tours.tourDashboardFilters,
    tourDashboardFiltersFinished: state.tours.tourDashboardFiltersFinished
  }
}

const mapDispatchToProps = {
  editTourDashboard,
  setToursDashboardFilters,
  setStatusTourDashboard
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(BunkeyDashboardTour)))
